

/* アカウントモーダル */
let accountBtn = document.querySelector(".e_account_sp");
let accountMenu = document.querySelector(".p_accountNav");
let searchBtn = document.querySelector(".e_searchOpen1");
let searchBtn2 = document.querySelector(".e_searchOpen2");
let searchMenu = document.querySelector(".l_searchNav");
let triggerBtn = document.querySelector(".js_triggerBtn");
let triggerMenu = document.querySelector(".p_hamburgerNav");
let header = document.querySelector(".l_header");
let body = document.querySelector("body");
accountBtn.addEventListener("click", function () {
  triggerMenu.classList.remove("is-active");
  triggerBtn.classList.remove("is-active");
  searchMenu.classList.remove("is-active");
  searchBtn.classList.remove("is-active");
  accountBtn.classList.toggle("is-active");
  if (accountBtn.classList.contains("is-active")) {
    accountBtn.classList.add("is-active");
    accountMenu.classList.add("is-active");
    header.classList.add("is-active");
  } else {
    accountBtn.classList.remove("is-active");
    accountMenu.classList.remove("is-active");
    header.classList.remove("is-active");
  
  }
});
/* 検索モーダル */
searchBtn.addEventListener("click", function () {
  searchBtn.classList.toggle("is-active");
    triggerMenu.classList.remove("is-active");
    triggerBtn.classList.remove("is-active");
    accountMenu.classList.remove("is-active");
    accountBtn.classList.remove("is-active");
  
  if (searchBtn.classList.contains("is-active")) {
    searchMenu.classList.add("is-active");
    header.classList.add("is-active");
  } else {
    searchMenu.classList.remove("is-active");
    header.classList.remove("is-active");
  
  }
});
searchBtn2.addEventListener("click", function () {
  searchBtn2.classList.toggle("is-active");
      triggerMenu.classList.remove("is-active");
      triggerBtn.classList.remove("is-active");
    accountMenu.classList.remove("is-active");
    accountBtn.classList.remove("is-active");
    accountMenu.classList.remove("is-active");
  if (searchBtn2.classList.contains("is-active")) {
    searchMenu.classList.add("is-active");
    body.classList.add("is_fixed");
    header.classList.add("is-active");
  } else {
    searchMenu.classList.remove("is-active");
    body.classList.remove("is_fixed");
    header.classList.remove("is-active");
  
  }
});

/* ハンバーガーメニュー */

triggerBtn.addEventListener("click", function () {
  triggerBtn.classList.toggle("is-active");
      searchMenu.classList.remove("is-active");
      searchBtn.classList.remove("is-active");
      searchBtn2.classList.remove("is-active");
    accountMenu.classList.remove("is-active");
    accountBtn.classList.remove("is-active");
  if (triggerBtn.classList.contains("is-active")) {
    triggerMenu.classList.add("is-active");
    body.classList.add("is_fixed");
    header.classList.add("is-active");
  } else {
    triggerMenu.classList.remove("is-active");
    body.classList.remove("is_fixed");
    header.classList.remove("is-active");
    
  }
});



  const acc_ttl = Array.from(
    document.querySelectorAll(".b_footerNav_itemTtl")
);

for (let i = 0; i < acc_ttl.length; i++) {
    let ttl = acc_ttl[i];
    let content = ttl.nextElementSibling;
    ttl.addEventListener("click", () => {
        ttl.classList.toggle("is-active");
        console.log(content.style.height);
        if (content.style.height) {
            content.style.height = null;
        } else {
            content.style.height = content.scrollHeight + "px";
        }
    });
}

let select1 = document.querySelector('[name="searchSelect1"]');
let txt1_hidden = document.querySelector('.b_headerSearch_formCategoryInput1');
let select2 = document.querySelector('[name="searchSelect2"]');
let txt2_hidden = document.querySelector('.b_headerSearch_formCategoryInput2');
let txt1 = document.querySelector('.l_header .b_headerSearch_formInput1');
let txt2 = document.querySelector('.p_searchNav_top .b_headerSearch_formInput2');


  select1.addEventListener("change", function () {
    const selectedValue1 = select1.options[select1.selectedIndex].text;
    
    // 半角スペースを入れて検索ボックスのvalueとplaceholderを設定
    txt1.placeholder = selectedValue1;
    txt1_hidden.textContent = select1.value;
  });
  select2.addEventListener("change", function () {
    const selectedValue2 = select2.options[select2.selectedIndex].text;
    
    // 半角スペースを入れて検索ボックスのvalueとplaceholderを設定
    // txt2.placeholder = selectedValue2;
    txt2_hidden.textContent = select2.value;
  });

  document.getElementById("searchForm").addEventListener("submit", function(event) {
    const searchInput = document.querySelector('.l_header .b_headerSearch_formInput1');
    const additionalFilter = document.querySelector('.b_headerSearch_formCategoryInput1').textContent.replace(/,/g, " ");
    if(additionalFilter != "") {
    // カンマをスペースに置き換えた値をキーワードの先頭に追加
    // searchInput.value = additionalFilter + " " + searchInput.value;
      event.preventDefault();
      let searchURL = `/collections/${additionalFilter}?q=${searchInput.value}#ProductGridContainer`;
      window.location.href = searchURL;
    } else {
    searchInput.value = searchInput.value;
    }
  });
  document.getElementById("searchForm2").addEventListener("submit", function(event) {
    const searchInput2 = document.querySelector('.b_headerSearch_formInput2');
    const additionalFilter2 = document.querySelector('.b_headerSearch_formCategoryInput2').textContent.replace(/,/g, " ");
    
     if(additionalFilter2 != "") {
    // カンマをスペースに置き換えた値をキーワードの先頭に追加
    // searchInput2.value = additionalFilter2 + " " + searchInput2.value;
           event.preventDefault();
      let searchURL2 = `/collections/${additionalFilter2}?q=${searchInput2.value}#ProductGridContainer`;
      window.location.href = searchURL2;
    } else {
    searchInput2.value = searchInput2.value;
    }
  });

let searchButton = document.querySelector('.l_header .searchBtn');
let searchButtonSp = document.querySelector('.p_searchNav_top .searchBtn');
    searchButton.addEventListener("click", (e) => {
        if (txt1.value == "" && txt1_hidden.textContent == "") {
            e.preventDefault();
          window.location.href = "/collections/all"
        } else {
            document.searchForm1.submit();
        }
    });
    searchButtonSp.addEventListener("click", (e) => {
        if (txt2.value == "" && txt2_hidden.textContent == "") {
            e.preventDefault();
          window.location.href = "/collections/all"
        } else {
            document.searchForm2.submit();
        }
    });

if (window.matchMedia('(max-width: 767px)').matches) {
  function headerHeightCssCustomProperty() {
  const header = document.querySelector(".js_header"),
    headerHeight = header.clientHeight;
  return (
    document.documentElement.style.setProperty(
      "--header-height",
      headerHeight + "px"
    ),
    headerHeight
  );
}

    function headerInteraction() {
    const headerBottom = document.querySelector(".is-sp .p_header_category_nav"),
      header = document.querySelector(".l_header"),
      categoryIndex = document.querySelector("#shopify-section-template--17992184463610__yg_category_index_8U4MDe"),
      headerHeight = headerHeightCssCustomProperty(),
      headerBackground = document.querySelector(".l_header__background");
    let position = document.documentElement.scrollTop;
    window.addEventListener("scroll", () => {
      Math.trunc(position) < document.documentElement.scrollTop &&
      Math.trunc(position) > 1
        ? (headerBottom.classList.add("is-hidden"),header.classList.add("is-hidden"),categoryIndex && categoryIndex.classList.add("is-hidden"))
        : (headerBottom.classList.remove("is-hidden"),header.classList.remove("is-hidden"),categoryIndex && categoryIndex.classList.remove("is-hidden")),
        (position = document.documentElement.scrollTop);
    });
  }
  document.addEventListener("DOMContentLoaded", () => {
    headerInteraction();
  });
}

